import config from '../config';

const HOST = config.api_host;

const API = {

  REPORT: {
    STORAGE: {
      GET_DATA: HOST +'/v2/api/web/report/storage'
    },
    FILE: {
      GET_DATA: HOST + '/v2/api/web/report/fileUpload'
    }, 
    DASHBOARD: HOST + '/v2/api/web/report/dashboard'
  },

  LOGIN: {
    GET_OTP : HOST + '/v2/api/login/gen-otp',
    REGET_OTP: HOST + '/v2/api/login/resend-otp',
    SENT_OTP: HOST + '/v2/api/login'
  },

  USER: {
    AUTO_COMPLETE: HOST + '/v2/api/web/user/autocomplete',
    AUTO_COMPLETE_DEPARTMENT: (key_search) => HOST + '/v2/api/web/user/load-dept?key_search=' + key_search,
    GET_LIST_PROJECT_OF_USER: (typeProject) =>  HOST + '/v2/api/web/user/get-projects-of-user' + `?typeProject=${typeProject}`,

    GET_USERS: (projectName, pageNum, perPage) =>  HOST + '/v2/api/project/user/list' + `?project_name=${projectName}&page_number=${pageNum}&per_page=${perPage}`,

    GET_LIST_ROLE: (apiKey) => HOST + '/v2/api/permission/role/list' + `?api_key=${apiKey}`,

    CREATE_USER_INFO: HOST + '/v2/api/web/user',
    ADD_PERMISSION: HOST + '/v2/api/project/user',
    EDIT_PERMISSION: HOST + '/v2/api/project/user',

    DELETE_USER: HOST + '/v2/api/project/user/delete'
  },

  STORAGE: {
    GET_LIST_PROJECT: (page_number, per_page) => HOST + '/v2/api/project/list'+'?page_number='+page_number+'&per_page='+per_page+'',
    ADD_NEW_PROJECT: HOST + '/v2/api/project',
    DELETE_PROJECT: HOST + '/v2/api/project',
    EDIT_PROJECT: HOST + '/v2/api/project'
  }

};

export default API;
